(function () {
  var hoverGridSwiper;
  var resizeTimer;

  function initHoverGridSwiper() {
    if (typeof Swiper === 'undefined' || !document.querySelector('.js-hover-grid')) return;

    var isMobile = window.innerWidth < 768;

    if (isMobile && !hoverGridSwiper) {
      hoverGridSwiper = new Swiper('.js-hover-grid', {
        slidesPerView: 1,
        spaceBetween: 16,
        grid: { rows: 2, fill: 'row' },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: { el: '.swiper-pagination', clickable: true },
        observer: true,
        observeParents: true,
      });
    }

    if (!isMobile && hoverGridSwiper) {
      hoverGridSwiper.destroy(true, true);
      hoverGridSwiper = null;
    }
  }

  window.addEventListener('load', initHoverGridSwiper);
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initHoverGridSwiper, 150);
  }, { passive: true });
})();
